import { render, staticRenderFns } from "./ShowClients.vue?vue&type=template&id=b76e0304&"
import script from "./ShowClients.vue?vue&type=script&lang=js&"
export * from "./ShowClients.vue?vue&type=script&lang=js&"
import style0 from "./ShowClients.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports